/**
 * Validation helpers for feed purchase events.
 *
 * These helpers are separated from FeedPurchaseEvents.tsx
 * to enable Fast Refresh. Non-component exports in the same file as components
 * break HMR.
 */

import { Dispatch, SetStateAction } from "react";

export const checkConsistency = (
  feedType: string | undefined,
  setFeedTypeError: Dispatch<SetStateAction<boolean>>,
  feedUnit: string | undefined,
  setFeedUnitError: Dispatch<SetStateAction<boolean>>,
  date: Date | null,
  setDateError: Dispatch<SetStateAction<boolean>>,
  dateError: boolean,
  feedAmount: string | undefined,
  setFeedAmountError: Dispatch<SetStateAction<boolean>>,
  cost: string | undefined,
  setCostError: Dispatch<SetStateAction<boolean>>
) => {
  // check for wrong input
  if (!feedType) {
    setFeedTypeError(true);
  }
  if (!date) {
    setDateError(true);
  }

  if (!feedUnit) {
    setFeedUnitError(true);
  }
  if (!feedAmount) {
    setFeedAmountError(true);
  }

  const feedAmountNumber = Number(feedAmount ?? "");
  const feedAmountError: boolean =
    Number.isNaN(feedAmountNumber) || feedAmountNumber <= 0;
  setFeedAmountError(feedAmountError);

  const costNumber = Number(cost ?? "");
  const costError: boolean = Number.isNaN(costNumber) || feedAmountNumber < 0;
  setCostError(costError);

  if (
    !feedType ||
    !date ||
    !feedUnit ||
    dateError ||
    feedAmountError ||
    costError
  ) {
    return false;
  }
  return true;
};
